// URL oficial da biblioteca Player.js servida pela CDN do Bunny. É ela que abre o canal
// de mensagens com o iframe do player (play, pause, timeupdate, ended).
const PLAYER_JS_SRC = 'https://assets.mediadelivery.net/playerjs/playerjs-latest.min.js';

// O script é global: carregado uma vez por sessão, não uma vez por vídeo. A promessa fica
// em módulo para que dois componentes montados ao mesmo tempo compartilhem o mesmo load.
let loadPromise = null;

/**
 * Carrega o Player.js sob demanda e resolve com o objeto global `playerjs`.
 *
 * Fica fora do bundle porque a Central de Ajuda é uma tela só: embutir a biblioteca
 * pesaria em todas as outras. Rejeita quando o script não carrega (bloqueador de conteúdo,
 * rede da barbearia com filtro), e nesse caso a tela mantém o vídeo tocando sem os
 * eventos de progresso.
 */
export function loadBunnyPlayerJs() {
    if (window.playerjs) {
        return Promise.resolve(window.playerjs);
    }

    if (loadPromise) {
        return loadPromise;
    }

    loadPromise = new Promise((resolve, reject) => {
        // Reaproveita a tag quando outro trecho já a inseriu, para não baixar duas vezes.
        const existing = document.querySelector(`script[src="${PLAYER_JS_SRC}"]`);
        const script = existing || document.createElement('script');

        script.addEventListener('load', () => {
            if (window.playerjs) {
                resolve(window.playerjs);
            } else {
                reject(new Error('Player.js carregado sem expor a API global'));
            }
        });
        script.addEventListener('error', () => {
            // Zera para permitir nova tentativa numa próxima visita à tela.
            loadPromise = null;
            reject(new Error('Não foi possível carregar o Player.js'));
        });

        if (!existing) {
            script.src = PLAYER_JS_SRC;
            script.async = true;
            document.body.appendChild(script);
        }
    });

    return loadPromise;
}
